import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入语言资源
import enTranslation from './locales/en.json';
import zhTranslation from './locales/zh.json';
import jaTranslation from './locales/ja.json';
import koTranslation from './locales/ko.json';
import esTranslation from './locales/es.json';
import frTranslation from './locales/fr.json';
import zhTWTranslation from './locales/zh-TW.json';
import itTranslation from './locales/it.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enTranslation
      },
      zh: {
        common: zhTranslation
      },
      ja: {
        common: jaTranslation
      },
      ko: {
        common: koTranslation
      },
      es: {
        common: esTranslation
      },
      fr: {
        common: frTranslation
      },
      'zh-TW': {
        common: zhTWTranslation
      },
      it: {
        common: itTranslation
      }
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    defaultNS: 'common'
  });

export default i18n; 